import React, {createContext, useContext, useState} from 'react';

export const LisensContext = createContext();

export const useLisensContext = () =>{
  return useContext(LisensContext);
};

export const LisensProvider = ({children}) =>{
  const [data,setData] = useState({
    jegernr: '',
    lisenser: [],
    jaktaar: '',
  });

  return (
    <LisensContext.Provider value={[data,setData]}>
      {children}
    </LisensContext.Provider>
  );
};
